export default "__VITE_ASSET__BZSLl51d__"